import { cva } from 'class-variance-authority';

export const linkVariants = cva(
  [
    'text-charcoal-500 hover:text-charcoal-700 cursor-pointer leading-normal font-medium transition-colors duration-200 ease-in-out'
  ],
  {
    variants: {
      underline: {
        true: 'underline',
        false: 'no-underline hover:underline'
      }
    },
    defaultVariants: {
      underline: false
    }
  }
);
